import React from 'react';
import { TextField, MenuItem } from '@material-ui/core';
import { RootState } from '../store';
import { connect, ConnectedProps } from 'react-redux';
import { DamageGroup } from '../store/common';

interface ComponentProps {
  value?: string
  damageGroup?: DamageGroup
  onChange?: (value: string) => void
}

const mapStateToProps = (state: RootState) => ({
  damageTypes: state.options.damageTypes,
})

const connector = connect(mapStateToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;
type Props = PropsFromRedux & ComponentProps;

const DamageTypeSelect: React.FunctionComponent<Props> = ({ damageTypes, value, damageGroup, onChange }) => (
  <TextField
    fullWidth
    select
    label="Type"
    value={value || ''}
    onChange={(event) => onChange && onChange(event.target.value)}
    style={{ minWidth: 100 }}
  >
    {damageTypes.map((item) => (
      <MenuItem key={item.value} value={item.value}>{item.label}</MenuItem>
    ))}
  </TextField>
);

export default connector(DamageTypeSelect);
